import { useCallback, useState } from 'react';

export const useSearch = () => {
  const [searchValue, setSearchValue] = useState<string>('');
  const onKeyEnterSearch = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      setSearchValue(e.currentTarget.value);
      e.preventDefault();
      e.currentTarget.blur();
    },
    [],
  );

  const initSearchValue = useCallback(() => {
    setSearchValue('');
  }, []);

  return {
    onKeyEnterSearch,
    initSearchValue,
    searchValue,
  };
};
